import { useEffect, useState } from "react";
import api from "../api";
import { Modal } from "./ui";

const STATUS_IT = { active: "In corso", completed: "Completato", stopped: "Fermato" };

export default function DripFunnel() {
  const [cfg, setCfg] = useState(null);
  const [enr, setEnr] = useState([]);
  const [stats, setStats] = useState(null);
  const [preview, setPreview] = useState(null); // {idx, subject, html}
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => {
    api.get("/drip/config").then((r) => setCfg(r.data)).catch(() => {});
    api.get("/drip/enrollments").then((r) => setEnr(r.data)).catch(() => {});
    api.get("/drip/stats").then((r) => setStats(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const toggle = async (enabled) => {
    setBusy(true);
    try { const r = await api.put("/drip/config", { enabled, interval_days: cfg.interval_days }); setCfg(r.data); setMsg(enabled ? "Funnel attivo: le nuove conferme privacy riceveranno la serie." : "Funnel in pausa."); }
    catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const saveInterval = async (days) => {
    const d = Math.max(1, parseInt(days || 7, 10));
    const r = await api.put("/drip/config", { enabled: cfg.enabled, interval_days: d });
    setCfg(r.data);
  };

  const enrollConfirmed = async () => {
    if (!window.confirm("Iscrivere al funnel tutti i contatti che hanno già confermato il consenso? Riceveranno la Lezione 1 entro pochi minuti, poi una a settimana.")) return;
    setBusy(true);
    try { const r = await api.post("/drip/enroll-confirmed"); setMsg(`${r.data.enrolled} contatti iscritti al funnel.`); load(); }
    catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const openPreview = async (idx) => {
    try { const r = await api.get(`/drip/preview/${idx}`); setPreview(r.data); }
    catch (e) { setMsg("Errore anteprima: " + (e.response?.data?.detail || e.message)); }
  };

  const sendTest = async (idx) => {
    const email = window.prompt("Invia una prova di questa lezione a quale indirizzo?", "casali.silvia@gmail.com");
    if (!email) return;
    setBusy(true);
    try { const r = await api.post("/drip/test", { email, idx }); setMsg(`Prova inviata a ${r.data.to}.`); }
    catch (e) { setMsg("Invio non riuscito: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const stopEnr = async (id) => { if (!window.confirm("Fermare la serie per questo contatto?")) return; await api.post(`/drip/enrollments/${id}/stop`); load(); };
  const resumeEnr = async (id) => {
    try { await api.post(`/drip/enrollments/${id}/resume`); setMsg("Serie riattivata: riparte dalla lezione a cui era rimasta."); load(); }
    catch (e) { setMsg("Non riattivabile: " + (e.response?.data?.detail || e.message)); }
  };

  if (!cfg) return null;

  return (
    <div className="panel" data-testid="drip-panel" style={{ marginBottom: 18 }}>
      <div className="toolbar" style={{ alignItems: "flex-start" }}>
        <div>
          <h3 style={{ margin: 0 }}>Serie educativa automatica — "I numeri che contano"</h3>
          <p className="muted" style={{ margin: "4px 0 0", maxWidth: 620 }}>
            6 email, una ogni {cfg.interval_days} giorni, che partono <strong>automaticamente quando un contatto conferma il consenso privacy</strong>. La Lezione 1 parte subito, le altre a cadenza regolare. Ogni email include i link per disiscriversi.
          </p>
        </div>
        <div className="spacer" />
        <label style={{ display: "flex", alignItems: "center", gap: 8, whiteSpace: "nowrap" }} data-testid="drip-toggle-label">
          <input type="checkbox" checked={cfg.enabled} onChange={(e) => toggle(e.target.checked)} disabled={busy} data-testid="drip-enabled" />
          <strong style={{ color: cfg.enabled ? "#16a34a" : "#94a3b8" }}>{cfg.enabled ? "Funnel ATTIVO" : "Funnel in pausa"}</strong>
        </label>
      </div>

      <div className="seg-cards" style={{ marginTop: 14, gridTemplateColumns: "repeat(4,1fr)" }}>
        <div className="seg-card" data-testid="drip-stat-active"><div className="lbl" style={{ fontSize: 22 }}>{cfg.stats.active}</div><div className="desc">in corso</div></div>
        <div className="seg-card"><div className="lbl" style={{ fontSize: 22 }}>{cfg.stats.completed}</div><div className="desc">completati</div></div>
        <div className="seg-card"><div className="lbl" style={{ fontSize: 22 }}>{cfg.stats.confirmed_optin}</div><div className="desc">consensi confermati</div></div>
        <div className="seg-card"><div className="lbl" style={{ fontSize: 22 }}>{cfg.stats.stopped}</div><div className="desc">fermati</div></div>
      </div>

      <div className="toolbar" style={{ marginTop: 14, gap: 10, flexWrap: "wrap" }}>
        <label className="muted" style={{ display: "flex", alignItems: "center", gap: 6 }}>
          Intervallo:
          <input type="number" min="1" value={cfg.interval_days} onChange={(e) => setCfg({ ...cfg, interval_days: e.target.value })} onBlur={(e) => saveInterval(e.target.value)} style={{ width: 64 }} data-testid="drip-interval" /> giorni
        </label>
        <button className="btn sm" onClick={enrollConfirmed} disabled={busy} data-testid="drip-enroll-confirmed">Iscrivi i {cfg.stats.confirmed_optin} contatti già confermati</button>
        {msg && <span className="muted" data-testid="drip-msg">{msg}</span>}
      </div>

      <table style={{ marginTop: 16 }} data-testid="drip-lessons-table">
        <thead><tr><th>#</th><th>Lezione</th><th title="Email inviate">Inviate</th><th title="Hanno aperto">Aperte</th><th title="Lette fino in fondo (stima)">In fondo</th><th title="Hanno cliccato un link">Clic</th><th></th></tr></thead>
        <tbody>
          {cfg.lessons.map((l) => {
            const s = (stats?.lessons || []).find((x) => x.idx === l.idx) || { sent: 0, opened: 0, read_bottom: 0, clicked: 0 };
            const pct = s.sent ? Math.round((s.opened / s.sent) * 100) : 0;
            return (
            <tr key={l.idx} data-testid={`drip-lesson-${l.idx}`}>
              <td style={{ color: "#c8a35b", fontWeight: 700 }}>{l.idx + 1}</td>
              <td>{l.title}<div className="muted" style={{ fontSize: 12 }}>{l.subject}</div></td>
              <td data-testid={`drip-sent-${l.idx}`}>{s.sent}</td>
              <td>{s.opened}{s.sent ? <span className="muted"> ({pct}%)</span> : null}</td>
              <td>{s.read_bottom}</td>
              <td>{s.clicked}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                <button className="btn sm" onClick={() => openPreview(l.idx)} data-testid={`drip-preview-${l.idx}`}>Anteprima</button>{" "}
                <button className="btn sm" onClick={() => sendTest(l.idx)} disabled={busy} data-testid={`drip-test-${l.idx}`}>Prova</button>
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
      <p className="muted" style={{ fontSize: 12, marginTop: 6 }}>Le statistiche (aperture, lettura, clic) si popolano con gli invii reali del funnel. "In fondo" è una stima: alcuni programmi di posta caricano tutte le immagini insieme. Non è tecnicamente possibile sapere chi cestina o inoltra un'email.</p>

      {enr.length > 0 && (
        <>
          <h4 style={{ margin: "20px 0 6px" }}>Contatti iscritti ({enr.length})</h4>
          <table data-testid="drip-enrollments-table">
            <thead><tr><th>Email</th><th>Lezione attuale</th><th>Stato</th><th>Prossimo invio</th><th></th></tr></thead>
            <tbody>
              {enr.slice(0, 200).map((e) => (
                <tr key={e.id} data-testid={`drip-enr-${e.id}`}>
                  <td>{e.email}</td>
                  <td className="muted">{Math.min((e.step || 0) + 1, cfg.total_lessons)} / {cfg.total_lessons}</td>
                  <td><span className={"pill " + (e.status === "active" ? "gestita" : "da_gestire")}>{STATUS_IT[e.status] || e.status}{e.status === "stopped" && e.stop_reason ? ` (${e.stop_reason})` : ""}</span></td>
                  <td className="muted">{e.status === "active" && e.next_send_at ? new Date(e.next_send_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—"}</td>
                  <td>
                    {e.status === "active" && <button className="btn sm danger" onClick={() => stopEnr(e.id)} data-testid={`drip-stop-${e.id}`}>Ferma</button>}
                    {e.status === "stopped" && <button className="btn sm" onClick={() => resumeEnr(e.id)} data-testid={`drip-resume-${e.id}`}>▶ Riprendi</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {preview && (
        <Modal title={`Anteprima — ${preview.subject}`} onClose={() => setPreview(null)} wide>
          <iframe title="anteprima-email" sandbox="" srcDoc={preview.html} data-testid="drip-preview-iframe" style={{ width: "100%", height: "70vh", border: "1px solid var(--line, #22222e)", borderRadius: 10, background: "#0d0d14" }} />
          <div className="modal-actions">
            <button className="btn" onClick={() => setPreview(null)}>Chiudi</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
